import { UserX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cognitoLogout } from "@/lib/auth";
import { usePageTitle } from "@/hooks/usePageTitle";

export default function AccountDeactivated() {
  usePageTitle('Account Deactivated | BookMyCoaching');
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="mx-auto w-16 h-16 rounded-full bg-muted flex items-center justify-center">
          <UserX className="w-8 h-8 text-muted-foreground" />
        </div>
        <h1 className="text-2xl font-semibold text-foreground">Your account has been deactivated</h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          You cannot sign in right now. If you think this is a mistake or want to know more,
          contact our support team at{" "}
          <a href="mailto:support@bookmycoaching.com" className="text-primary underline underline-offset-2">
            support@bookmycoaching.com
          </a>.
        </p>
        <Button onClick={() => cognitoLogout()} className="w-full h-11">
          Sign out
        </Button>
      </div>
    </div>
  );
}
